import { themeEl } from "@app/ui/utils/dom/root-el";

export function setThemeColor(key: string, value: string) {
  themeEl?.style.setProperty(key, value);
}
